module.exports = __webpack_public_path__ + "img/R1-05934-0030_Original.4bdf3a92.jpg";